<template>
  <div class="home-container" id="home-top">

    <!-- 试用期/断服公告/ 提醒 -->
    <TrialRemind />
    <OfServiceRemind />
    <ExpirationRemind v-if="hasAdminAccount && [1,2].includes(accRoleType)" />

    <div class="home-content">
      <span v-if="permission.verify('tab_brand')" class="change-skin-btn c_pointer" @click="handleClickToPage('/company-set/index?tab=brand')">
        <el-tooltip :offset="-15" effect="light" placement="bottom" :content="$xinI18n('去设置专属背景，提升企业文化宣传度','home-genghuanbeijing')">
          <img src="//static.xinrenxinshi.com/unicorn/img/home/home-bg-right-top.png" />
        </el-tooltip>
      </span>

      <!-- 搜索和启动台 -->
      <div v-if="hasAdminAccount && !isWhiteLabel" class="top-box">
        <XinGlobalSearch modal="home" @linkClick="linkClick" :isWhiteBg="true" ref="XinGlobalSearch" />
        <StartStationBtn />
      </div>

      <!-- 主体-左侧卡片，右侧信息和日历 -->
      <el-row :gutter="16" class="main">
        <el-col :span="16" class="left" :style="{'min-height':`calc(100vh - ${hasAdminAccount ? '152px':'88px'})`}">
          <XinWbLayout
            ref="xinWbLayoutRef"
            module="home"
            :colum-num="2"
            ajax-url="/xsearch/service/admin/home/ajaxGetHomePageWorkTab"
            top-ajax-url="/xsearch/service/admin/home/ajaxSetTabTop"
            :label-list="labelList"
            @cardOperate="handleOperate"
          />
        </el-col>
        <el-col :span="8" class="right">
          <div class="right-content" :style="{'min-height':`calc(100vh - ${hasAdminAccount ? '152px':'88px'})`}">
            <UserMessage :app-setting="appSetting" />
            <CalendarSchedule :apply-list="applyList" :app-setting="appSetting" />
            <!-- 纯管理员不展示员工端快捷入口 -->
            <QuickEntrance v-if="hasEmployeeAccount" :apply-list="applyList" :app-setting="appSetting" />
            <LatestNews v-if="isFeatureEnabled && hasAdminAccount" />
          </div>
        </el-col>
      </el-row>
    </div>

    <span id="home-page-totop" class="to-top c_pointer" @click="toTop">
      <xin-icon xin-type="xicon-arrow-up-line1" />
    </span>

    <template v-if="hasEmployeeAccount">
      <!-- 审批操作弹窗 -->
      <XinWbApproveOperateEmployeePass ref="approveOperatePassRef" @success="handleCardOperateCb" />
      <XinWbApproveOperateEmployeeReason ref="approveOperateReasonRef" @success="handleCardOperateCb" />
      <XinWbApproveOperateEmployeeUrge ref="approveOperateUrgeRef" @success="handleCardOperateCb" />
    </template>

    <template v-if="hasAdminAccount">
      <!-- 员工操作-续签主合同 -->
      <XinWbEmployeeOperateRenewContract ref="employeeOperateRenewContractRef" @after-operate="handleCardOperateCb" />
    </template>

    <!-- 低代码上线引导弹框 -->
    <xin-new-guide-dialog
      class="aa"
      :company-id="companyId"
      :acc-id="accId"
      :head-id="headId"
      :guide-type="4"
      v-if="isFeatureEnabled && accId && headId && companyId"
    />
  </div>
</template>

<script lang="ts">
  import {Component, Vue,Watch,Mixins} from 'vue-property-decorator';
  import {throttle} from 'lodash-es'
  import {HomeApi} from '@/module/home/service/home-api.service';
  import {namespace} from 'vuex-class';
  import { XinWbLayout } from '@xin/xin-workbench'
  import { XinNewGuideDialog, XinGlobalSearch } from "@xin/xin-ui"
  // import XinGlobalSearch from "@xin/xin-ui/src/components/xin-global-search/index"
  import StartStationBtn from '../components/start-station/index.vue'
  import TrialRemind from "../components/reminds/trial-remind.vue"
  import OfServiceRemind from '../components/reminds/of-service-remind.vue'
  import ExpirationRemind from '../components/reminds/expiration-remind.vue'
  import UserMessage from "../components/user-message/index.vue"
  import CalendarSchedule from "../components/calendar-schedule/index.vue"
  import QuickEntrance from "../components/quick-entrance/index.vue"
  import LatestNews from "../components/latest-news/index.vue"

  import EmployeeOperateMixin from './mixin/employee-operate-mixin'
  import ApproveOperateMixin from './mixin/approve-operate-mixin'

  const moduleInfra = namespace('moduleInfra');

  interface TTableListItem {
    name:string,
    id:string
  }
  interface TOperateItem {
    operateKey:string;
    module:string;
    cardRef:string;
    data:any
  }

  @Component({
    components: {
      TrialRemind,
      OfServiceRemind,
      ExpirationRemind,
      XinNewGuideDialog,
      XinWbLayout,
      StartStationBtn,
      UserMessage,
      CalendarSchedule,
      QuickEntrance,
      LatestNews,
      XinGlobalSearch
    }
  })
  export default class Index extends Mixins(EmployeeOperateMixin,ApproveOperateMixin) {
    $refs!:{
      xinWbLayoutRef:any;
    }
    //公司和用户信息
    @moduleInfra.Getter('getCompanyId') public companyId!: string;
    @moduleInfra.Getter('getHeadId') public headId!: string;
    @moduleInfra.Getter("getAccId") public accId!: string;
    @moduleInfra.Getter('getRoleType') public accRoleType!: number;
    //身份标识
    @moduleInfra.Getter('getHasAdminAccount') public hasAdminAccount!: number;
    @moduleInfra.Getter('getHasEmployeeAccount') public hasEmployeeAccount!: number;
    @moduleInfra.Getter('getEmployeeBasicInfo') public employeeBasicInfo!: any;

    scrollTop = 0
    labelList:TTableListItem[] = []
    applyList:any = []
    rightRect:any = null
    homePageBg = {
      homePageBackgroundUrl:'',
      homePageBackgroundType:1
    }
    cardOperateData:any = {}
    isFeatureEnabled = window.deployFunctionSwitch && window.deployFunctionSwitch.userCenter === '1'
    isWhiteLabel = window.deployFunctionSwitch && window.deployFunctionSwitch.whiteLabel === '1'

    @Watch('$route',{immediate:true,deep:true})
    routerChange(val:any){
      this.linkClick({jumpParam:val.query})
    }
    get appSetting(){
      return this.employeeBasicInfo ? this.employeeBasicInfo.appSetting : {}
    }
    created() {
      this.gethomePageBg()
      this.getLabelList()
      this.getApplyList()
    }
    mounted(){
      this.initDomEvent()
      document.removeEventListener("click", this.close);
      document.addEventListener('click', this.close)
    }
    //点击区域外的位置取消高亮
    close(e: any) {
      //删除其他高亮卡片
      const homePontAll:any = document.querySelector('#home_point_all');
      if(homePontAll){
        for (let i = 0; i < homePontAll.children.length; i++) {
          homePontAll.children[i].firstChild.classList.remove('sk-border');
          homePontAll.children[i].firstChild.classList.remove('search-home-border');
        }
      }
    }
    //emit过来的-全是首页的搜索-不是header的搜索 header的得走路由监听
    linkClick(data:any){
      const {labelType,tabType} = data.jumpParam;

      if(labelType || labelType === ''){
        this.$nextTick(()=>{
          //设置高亮首页标签
          if(this.$refs.xinWbLayoutRef.$refs.cardLabelList){
            this.$refs.xinWbLayoutRef.$refs.cardLabelList.setActive(labelType)
          }
        })
        setTimeout(()=>{
          //外部跳转延迟设置高亮首页标签
          if(this.$refs.xinWbLayoutRef.$refs.cardLabelList){
            this.$refs.xinWbLayoutRef.$refs.cardLabelList.setActive(labelType)
          }
          if(!tabType){
            const targetElement:any = document.querySelector('#card_label_list_11');
            targetElement.scrollIntoView({behavior: 'smooth',});
          }
        }, 650)
      }
      this.executeWithDelay(tabType,(targetElement:any)=>{
        if(tabType && targetElement){
          setTimeout(()=>{
            //子元素滚动
            targetElement.scrollIntoView({behavior: 'smooth',});
            //高亮卡片 home_search_point
            targetElement.firstChild.classList.add('sk-border')
            targetElement.firstChild.classList.add('search-home-border')
          },550)
        }
      })
    }
    //定时检查有无这个元素
    executeWithDelay(tabType:any,cb:any) {
      let intervalId:any = null;
      const startTime = Date.now();
      // 检查 targetElement 是否有值 并执行 console.log
      function checkAndLog() {
        if (document.querySelector('#home_point' + tabType) !== null) {
          cb(document.querySelector('#home_point' + tabType))
          clearInterval(intervalId);
        }else if(Date.now() - startTime > 10000){
          cb()
          clearInterval(intervalId);
        }
      }
      intervalId = setInterval(checkAndLog, 200); // 每隔200ms检查 targetElement，并执行 checkAndLog 函数
    }
    //初始化滚动事件
    initDomEvent(){
      document.querySelector('#home .main-container')?.removeEventListener('scroll',this.handlePageScroll)
      document.querySelector('#home .main-container')?.addEventListener('scroll',this.handlePageScroll,false)
      document.querySelector('.xin-header .xin-header-search')?.classList.add('none')
    }
    //获取卡片筛选标签列表
    gethomePageBg(){
      HomeApi.ajaxGetHomePageBg().then((data:any)=>{
        if(data){
          this.homePageBg = data
        }
      }).finally(()=>{
        const { homePageBackgroundType, homePageBackgroundUrl } = this.homePageBg
          const url = homePageBackgroundUrl||`//static.xinrenxinshi.com/unicorn/img/home/home-page-bg${homePageBackgroundType}.png`
          const dom:any = document.querySelector('.main-container')
          if(url && dom && dom.style){
            dom.style.backgroundImage = `url(//static.xinrenxinshi.com/unicorn/img/home/home-page-bg-modal2.png),url(${url})`
          }
      })
    }

    //获取卡片筛选标签列表
    getLabelList(){
      HomeApi.ajaxGetLabelList().then((data:any)=>{
        if(data && data.length){
          this.labelList = data.map((label:{labelName:string,labelType:string}) => ({name:label.labelName,id:label.labelType}))
        }
      })
    }

    //获取审批设置列表
    getApplyList(){
      if(!this.hasEmployeeAccount) return
      HomeApi.ajaxGetApplyList().then((data:any)=>{
        if(data){
          this.applyList = data.applyList
        }
      })
    }

    //卡片上操作
    handleOperate(res:TOperateItem){
      console.log('----操作-----',res);
      const { operateKey, module, data } = res
      this.cardOperateData = res
      if(module == '02'){ //员工
        this.employeeOperate(operateKey,data)
      }else if(module == '06'){
        this.approveOperate(operateKey,data)
      }
    }

    onScroll = throttle(this.handlePageScroll,200)

    //滚动事件
    handlePageScroll(e:any){
      const { scrollTop, offsetHeight } = e.target
      this.scrollTop = scrollTop
      const homePageTotopDom = document.querySelector('#home-page-totop')
      // const body:any = document.querySelector('body')
      const searchInputDom:any = document.querySelector('.home-content .xin-global-search .search-input')
      const inputRect = searchInputDom && searchInputDom.getBoundingClientRect()

      //控制header上搜索框和页面搜索框不同时出现
      if(inputRect){
        if(inputRect.top < 10){
          document.querySelector('.xin-header .xin-header-search')?.classList.remove('none')
          //@ts-ignore
          // this.$refs.XinGlobalSearch.setShowResult()
        }else{
          document.querySelector('.xin-header .xin-header-search')?.classList.add('none')
        }
      }

      if(scrollTop > 50){
        homePageTotopDom?.classList.add('show')
      }else{
        homePageTotopDom?.classList.remove('show')
      }
    }

    //回到顶部
    toTop(){
      let dom:any = document.querySelector('#home-top');
      dom && dom.scrollIntoView();

      this.XrxsTracker.$track('a_homeClickPageTop','','')
    }

    //================操作回调=============
    handleCardOperateCb(res:any){
      console.log(res,'---------',this.cardOperateData);
      if(this.cardOperateData.cardRef){
        //@ts-ignore
        this.$refs.xinWbLayoutRef.updateSomeOneCard(this.cardOperateData.cardRef)
      }
      this.$router.replace({query:{
        type:'source'
      }})
    }

    //取品牌设置
    handleClickToPage(link:string){
      window.location.href = link
    }

  }
</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
  .to-top{
    display: none;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1;
    bottom: 232px;
    right: -20px;
    padding: 10px;
    box-sizing: content-box;
    transition:all 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) !important;
    &.show{
      display: flex;
    }
    &:hover{
      transform: translateX(-26px);
    }
    .xin-icon{
      padding: 11px;
      width: 40px;
      height: 40px;
      border-radius: 20px;
      box-shadow: 0px 2px 8px 0px var(--xs-border-color-primary);
      background: #fff;
      font-size: 18px;
      color: var(--xs-text-color-primary);
    }
  }

  .home-content{
    margin: 0 auto;
    min-width: 1280px;
    max-width: 1782px;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;

    .change-skin-btn{
      box-sizing: border-box;
      position: fixed;
      right: 40px;
      top: 48px;
      width: 28px;
      height: 18px;
      img{
        width: 100%;
      }
    }

    .top-box{
      position: relative;
      display: flex;
      max-width: 912px;
      margin: 0 auto 20px;
      ::v-deep {
        .home-result-list {
          z-index: 498!important;
        }
      }
    }

    .main{
      display: flex;
      align-items: flex-start;

      .left{
        flex: 1;
        overflow: hidden;
        padding: 0 8px;
      }
      .right{
        position: sticky;
        top: 28px;
        min-width: 414px;
        .right-content{
          // position: relative;
          box-sizing: border-box;
          padding-left: 8px;
          padding-right: 8px;
          padding-bottom: 32px;
          // min-height: calc(100vh - 152px);
          // width: 414px;
          border: solid 1px #fff;
          background: var(--xs-color-white) linear-gradient(180deg, #f4fafc 0%, #fafcff 100%);
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.02);
          border-radius: 4px;
          border-top-left-radius: 12px;
          &.fixed{
            position: fixed;
            bottom: 0;
          }
          &::before{
            content: '';
            position: absolute;
            top: -20px;
            left: 8px;
            display: inline-block;
            width: 72px;
            height: 36px;
            border-radius: 36px 36px 0 0;
            background: #f4fafc;
            box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.05);
          }
        }
      }
    }
  }
}


</style>
<style lang="scss">
#home .main-container{
  background-repeat: no-repeat;
  background-size: 100%,100%;
  background-position: 0 0,0 0;
}
.translateX-24{
  transform: translateX(24px);
}
.xin-header .xin-header-search.none{
  display: none;
}
.home-bg{
  position: fixed;
  z-index: 0;
  top: 48px;
  left: 0;
  right: 0;
  img{
    width: 100%;
    min-height: 240px;
    object-fit: cover;
  }
}
</style>
